"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _breakLines = require("../../../utils/breakLines");
var _speakerCardUtils = require("../../speakerCard/speakerCardUtils");
var _sortAlphabetically = require("../../../utils/sortAlphabetically");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const SpeakersPage = props => {
  let {
    t = key => key,
    title,
    header,
    subheading,
    speakersData
  } = props;
  title = title || t('Pages.Speakers.Title');
  header = header || t('Pages.Speakers.Header');
  subheading = subheading || t('Pages.Speakers.Heading');
  (0, _react.useEffect)(() => {
    document.title = title;
  }, []);
  speakersData = (0, _sortAlphabetically.sortJson)(speakersData, 'name');
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "con-container"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "con-content"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "con-title-container con-title-container__speakers"
  }, (0, _breakLines.breakLines)(header, 'con-heading con-heading__h3'), (0, _breakLines.breakLines)(subheading, 'con-subtitle con-text con-text__Xtra-larger-regular')), /*#__PURE__*/_react.default.createElement("div", {
    className: "con-speakers"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "speakers-content"
  }, /*#__PURE__*/_react.default.createElement(_speakerCardUtils.SpeakersRenderListOfCards, {
    assets_directory: t("Common.AssetsDirectory"),
    page: "speakers",
    people: speakersData,
    grid: 4
  })))));
};
SpeakersPage.propTypes = {
  t: _propTypes.default.func,
  title: _propTypes.default.string,
  header: _propTypes.default.string,
  subheading: _propTypes.default.string,
  speakersData: _propTypes.default.array
};
var _default = exports.default = SpeakersPage;